import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './i18n/en.json';
import Storage from "./services/Storage";

const resources = {
	en: { translation: en }
};

const defaultLang = 'en';
const storage = new Storage();
const state = storage.get('_state');

let lang =	state && state.lang ? state.lang : defaultLang;

i18n
	.use(initReactI18next)
	.init({
				resources,
				lng: lang,
				fallbackLng: defaultLang
	});

i18n.changeLanguage(lang);

export default i18n;